import Clipboard from "@stimulus-components/clipboard";

export default class extends Clipboard {
}